import { UserRole } from "~/auth/types/roles";

export const AuthUtils = {
  isAdmin(roles: UserRole[]): boolean {
    return roles.includes(UserRole.ADMIN);
  }
}